import {
  UPDATE_BUSINESS_REVENUE,
  UPDATE_BUSINESS_START_YEAR,
  SET_MODAL_COMPLETE_BUSINESS_PROFILE,
} from './constants';

export function updateBusinessRevenue(id, businessRevenue) {
  return {
    type: UPDATE_BUSINESS_REVENUE,
    payload: { businessId: id, revenue: businessRevenue },
  };
}

export function updateBusinessSstart(id, businessStart) {
  return {
    type: UPDATE_BUSINESS_START_YEAR,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payload: { businessId: id, start_year: businessStart },
  };
}

export function setModalCompleteBusinessProfile(params) {
  return {
    type: SET_MODAL_COMPLETE_BUSINESS_PROFILE,
    payload: { showWelcomeModal: params },
  };
}
